import React from 'react';
import { themes } from '@olist/design-system-tokens';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';

const DEFAULT_PREFIX = 'olist';
const DEFAULT_THEME_NAME = 'olist';
const DEFAULT_VARIATION_NAME = 'base';
const FALLBACK_THEME_WARNING = '[olistds] Wrong theme specified. Loading fallback theme.';
const DEFAULT_THEME = themes[DEFAULT_THEME_NAME][DEFAULT_VARIATION_NAME];
const getTheme = (theme = DEFAULT_THEME_NAME, variation = DEFAULT_VARIATION_NAME) => {
    try {
        return (themes[theme][variation] || DEFAULT_THEME);
    }
    catch (e) {
        console.error(FALLBACK_THEME_WARNING);
    }
    return DEFAULT_THEME;
};
const ThemeProvider = ({ children, theme, variation }) => {
    const currentTheme = getTheme(theme, variation);
    return (React.createElement(ThemeProvider$1, { theme: {
            [DEFAULT_PREFIX]: currentTheme,
        } }, children));
};

export { FALLBACK_THEME_WARNING, ThemeProvider as default, getTheme };
